export default __webpack_public_path__ + "media/color/blcn-0e749041.svg";